import { createAction, props } from '@ngrx/store';
import { TopbarActions } from './actions';
import { Action } from '@app-models/action.model';

export const topbarSetState = createAction(
  TopbarActions.TOPBAR_SET_STATE,
  props<{ payload: Action[] }>()
);

export const topbarDeleteState = createAction(
  TopbarActions.TOPBAR_DELETE_STATE
);

export const clickedAction = createAction(
  TopbarActions.TOPBAR_CLICKED_ACTION,
  props<{ payload: string }>()
);

export const topbarResetClikedAction = createAction(
  TopbarActions.TOPBAR_RESET_CLICKED_ACTION
);

export const topBarSetTitle = createAction(
  TopbarActions.TOPBAR_SET_TITLE,
  props<{ title: string }>()
);
